import { PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import { cn } from '@/shared/cn';
import {
  FLOATING_HEADER_ICON,
  FLOATING_HEADER_ICON_BUTTON,
  FLOATING_HEADER_ICON_STROKE,
  HEADER_ICON_BUTTON,
} from '@/shared/ui-class';
import { useSidebarState } from '@/versions/v1/shared/SidebarStateContext';

export function SidebarToggle({
  variant = 'header',
}: {
  variant?: 'header' | 'sidebar';
}) {
  const { open: sidebarOpen, toggle: toggleSidebar } = useSidebarState();

  if (variant === 'header' && sidebarOpen) return null;

  const isHeaderVariant = variant === 'header';
  const Icon = sidebarOpen ? PanelLeftClose : PanelLeftOpen;
  const label = sidebarOpen ? 'Close sidebar' : 'Open sidebar';

  return (
    <div className="group relative inline-flex">
      <button
        type="button"
        onClick={toggleSidebar}
        aria-label={label}
        title={label}
        className={
          isHeaderVariant ? FLOATING_HEADER_ICON_BUTTON : HEADER_ICON_BUTTON
        }
      >
        <Icon
          className={isHeaderVariant ? FLOATING_HEADER_ICON : 'h-4 w-4'}
          strokeWidth={
            isHeaderVariant ? FLOATING_HEADER_ICON_STROKE : undefined
          }
        />
      </button>
      {isHeaderVariant && !sidebarOpen ? (
        <span
          aria-hidden
          className={cn(
            'pointer-events-none absolute left-0 top-full mt-2 whitespace-nowrap rounded-md',
            'border border-[var(--glass-border)] bg-[var(--glass-surface-strong)] backdrop-blur-xl',
            'px-2 py-1 text-xs font-medium text-zinc-600 dark:text-zinc-300',
            'shadow-[0_4px_12px_-6px_rgba(0,0,0,0.12)]',
            'opacity-0 transition-opacity duration-150 group-hover:opacity-100 group-focus-within:opacity-100',
          )}
        >
          Click to open
        </span>
      ) : null}
    </div>
  );
}
